import React from 'react';

import { useCreateTemplateFromReportModalLogic } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/CreateTemplateFromReportModal.logic';
import { useCreateTemplateFromReportModalProvider } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/CreateTemplateFromReportModal.provider';
import { CreateTemplateFromReportForm } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/CreateTemplateFromReportForm';
import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';

interface Props {
    isModalOpen: boolean;
    setIsModalOpen: (value: boolean) => void;
}

export const CreateTemplateFromReportModal = ({ isModalOpen, setIsModalOpen }: Props) => {
    const { api } = useCreateTemplateFromReportModalProvider();

    const { logic } = useCreateTemplateFromReportModalLogic({
        api,
        setIsModalOpen,
    });

    return (
        <Modal
            open={isModalOpen}
            onClose={logic.hideModal}
            title={'Create a Template based on this Report'}
            actions={
                <>
                    <Button size={'large'} variant={'secondary'} onClick={logic.hideModal}>
                        Cancel
                    </Button>
                    <Button
                        size={'large'}
                        variant={'primary'}
                        isLoading={api.createTemplateFromReport.instance.isLoading}
                        onClick={logic.form.handleSubmit(logic.handleSubmitForm)}
                    >
                        {logic.buttonText}
                    </Button>
                </>
            }
        >
            <CreateTemplateFromReportForm api={api} logic={logic} />
        </Modal>
    );
};
